module.exports = __webpack_public_path__ + "static/media/shoe.8bcaaaeb.png";